import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlertOutlinedSvg from "@ant-design/icons-svg/es/asn/AlertOutlined";
import AntdIcon from '../components/AntdIcon';
var AlertOutlined = function AlertOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: AlertOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(AlertOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'AlertOutlined';
}
export default RefIcon;